import { loadStripe } from "@stripe/stripe-js";
import { renderToStaticMarkup } from "react-dom/server";

import { jsonDataFormatter, jsonErrorFormatter } from "@stadium/helpers/formatter";

export const loadStripePromise = (key) => loadStripe(key);

export const serializeStripeError = (error, MailTo) => {
  const displayErrorMessage = `Your payment could not be processed. Please check your bank/credit card issuer and try again. If you still experience issues, please email ${renderToStaticMarkup(
    <MailTo />
  )}.`;
  return { ...error, displayErrorMessage };
};

export const createStripeSetupIntent = (client) => client.post("/credit_cards/create_setup_intent");

export const addCardApi = (client, payload) =>
  client
    .post("/credit_cards", payload)
    .then(jsonDataFormatter)
    .catch((error) => {
      const err = jsonErrorFormatter(error.response, "card");
      throw err;
    });

export const createPaymentError = (params) => ({
  error: params[0],
  params: { details: params, type: "Payment Error" },
});
